export const PAGE_SHORTCUTS = [
    {keys: 'Alt + 1', path: '/home', label: 'Главная'},
    {keys: 'Alt + 2', path: '/search', label: 'Поиск', focusSearch: true},
    {keys: 'Alt + 3', path: '/basket', label: 'Корзина'},
    {keys: 'Alt + 4', path: '/orders', label: 'Заказы'},
    {keys: 'Alt + 5', path: '/balance', label: 'Баланс'},
    {keys: 'Alt + 6', path: '/profile', label: 'Профиль'},
    // {keys: 'Alt + 7', path: '/catalog', label: 'Каталог'}
] as const;

export const AUTH_PATH_PREFIXES = [
    '/home',
    '/search',
    '/basket',
    '/orders',
    '/profile',
    '/catalog',
    '/balance',
    '/error'
];

export const SEARCH_FOCUS_SELECTOR = [
    '[data-keyboard-search] input',
    '[data-keyboard-search]',
    '.search-bar input',
    '.header-search-input input'
].join(', ');
